import { throttle } from "./throttle";

export const makeDrinksListsToggleable = () =>
  Array.from(
    document.querySelectorAll(
      "button[data-ref=drinks-toggle],button[data-ref=dishes-toggle]",
    ),
  ).forEach((toggleButton: HTMLButtonElement) => {
    const toggleable = toggleButton.parentElement?.querySelector(
      "[data-ref=drinks-toggleable],[data-ref=dishes-toggleable]",
    );

    const isDrinksListVisible = () =>
      !toggleable.classList.contains("visually-hidden");

    const toggleDrinksList = throttle(() => {
      const drinksVisible = isDrinksListVisible();

      toggleable.classList.toggle("visually-hidden", drinksVisible);
      // toggle class on the button to rotate the arrow
      toggleButton.classList.toggle("is-expanded", !drinksVisible);
    }, 500);

    if (toggleable) {
      toggleButton.addEventListener("click", toggleDrinksList);
    }
  });
